import getOr from 'lodash/fp/getOr';

export const getAllChairRentals = getOr([], 'barbers.chairRentals.items');

export const getChairRentalPaymentHistory = getOr([], 'barbers.chairRentals.paymentHistory');
